import styled from '@emotion/styled';
import {
  Avatar,
  Box,
  CircularProgress,
  Collapse,
  Divider,
  Drawer,
  Icon,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  mainAppBarDimen,
  // mainAppBarDimenResponsive,
  mainDrawerDimen,
  // mainDrawerDimenResponsive,
  mainLogoDimen,
  // mainLogoDimenResponsive,
  toPixel,
} from '../styles/dimensions';
import {
  ACTION_CLOSE_MAIN_DRAWER,
  ACTION_OPEN_MAIN_DRAWER,
  ACTION_RESET,
} from '../constants';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { mainDrawerJson } from '../data/mainDrawerJson';
import { useLocation, useNavigate } from 'react-router-dom';

import { auth, signOut } from '../../../firebase';
import _, { findIndex, replace } from 'lodash';
import MultyMedLogo from '../../../assets/MultyMedLogo';
import { useViewportSize } from '../styles/dimensions/viewportCustomHook';
import { useDispatch, useSelector } from 'react-redux';
import { setUserLanguage, setUserSettingResponse, setUserTheme } from '../../../redux/features/currentUserSlice';
import i18n from '../../../multilingual';
import { APP_NAME } from 'config/common-consts';
import { setProgress } from 'redux/features/progressSlice';
import { ehrAPIService } from 'adapters/http-common';

const openMixin = (theme) => {
  const isMobileResolution = window?.innerWidth <= 768;
  return {
    // width: mainDrawerDimen.open.width,
    width: !isMobileResolution && 55,
    '& .MuiDrawer-paper': {
      width: mainDrawerDimen.open.width,
      backgroundColor: theme.palette.drawerColor,
    },
  };
};

const closeMixin = theme => {
  return {
    width: mainDrawerDimen.closed.width,
    '& .MuiDrawer-paper': {
      width: mainDrawerDimen.closed.width,
      backgroundColor: theme.palette.drawerColor,
      overflowX: 'hidden',
    },
  };
};

const NVDrawer = styled(Drawer, {
  shouldForwardProp: props => true,
})(props => {
  console.log(props);
  const { theme, open } = props;

  return {

    ...(open && openMixin(theme)),
    ...(!open && closeMixin(theme)),
  };
});

const MDrawer = props => {

  let navigate = useNavigate();
  const reduxDispatch = useDispatch();
  const { mainDrawerOpen } = useMainFrameState();
  const dispatch = useMainFrameDispatch();

  const [mainDrawerJsonState, setMainDrawerJsonState] = useState(mainDrawerJson);
  const [cState, setCState] = useState({});

  const { width, height } = useViewportSize();
  const [loading, setLoading] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const currentUserSetting = useSelector(state => state.currentUser);
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClose = () => {
    setAnchorEl(null)
  }

  const changeLang = async (ln) => {
    setLoading('translate')
    handleClose()
    await updateUserSetting({ ...currentUserSetting, language: ln })
    // reduxDispatch(setUserLanguage(ln))
    i18n.changeLanguage(ln)
    setLoading(false)
  }

  const handleIsActive = someID => {
    const updatedMainDrawerJsonState = mainDrawerJsonState.map((ele, ind) => {
      if (ind === someID) {
        return { ...ele, isActive: true };
      } else {
        return { ...ele, isActive: false };
      }
    });

    setMainDrawerJsonState(updatedMainDrawerJsonState);
  };

  const handlePathnameRefresh = pathname => {

    setMainDrawerJsonState(
      mainDrawerJsonState.map((ele) => {
        if (pathname?.includes(ele.link?.split('/')[0])) {
          return { ...ele, isActive: true };
        } else {
          return { ...ele, isActive: false };
        }
      })
    );
  };

  const location = useLocation();
  const isMobileResolution = window?.innerWidth <= 768;
  const loggedInUserData = useSelector(state => state?.currentUser?.loggedInUserData)
  const isLoggedInAsAdmin = useSelector(
    state => state?.currentUser?.isLoggedInAsAdmin
  );

  useEffect(() => {
    handlePathnameRefresh(location.pathname?.split('/')?.[1]);
  }, [location, isDarkMode, isLoggedInAsAdmin]);

  useEffect(() => {
    if (currentUserSetting.theme === 'dark') {
      setIsDarkMode(true);
    } else {
      setIsDarkMode(false);
    }

  }, [currentUserSetting.theme])

  const updateUserSetting = async settings => {
    let setting = {
      theme: settings?.theme,
      language: settings?.language,
    };
    let payload = structuredClone(currentUserSetting?.userSettingsResponse);
    if (payload) {
      payload.extension = [
        {
          url: 'http://enliv.com/settings/data',
          valueString: JSON.stringify(setting),
        },
      ];
      try {
        reduxDispatch(setProgress(true));
        const response = await ehrAPIService.put(`updateResource`, payload);
        const rawData = { ...response?.data };
        const displaySetting = rawData?.extension?.find(
          item => item?.url === 'http://enliv.com/settings/data'
        )?.valueString;
        reduxDispatch(setUserTheme(JSON?.parse(displaySetting)?.theme));
        reduxDispatch(setUserLanguage(JSON?.parse(displaySetting)?.language));
        reduxDispatch(setUserSettingResponse(rawData));
      } catch (e) {
        console.error(e);
      } finally {
        reduxDispatch(setProgress(false));
      }
    }
  };

  const handleOnClick = async (event, isSubmenu = false, data) => {
    if (isSubmenu) {
      setCState({
        ...cState,
        [data.name]: !cState[data.name],
      });

      if (data.link === 'translate') {
        setAnchorEl({ ...event?.currentTarget });
      }
    } else {
      if (data.link === 'logout') {
        navigate(`/login`, {
          state: {
            isLogout: true,
          },
          replace: true,
        });
      } else if (data.link === 'current username') {
        return '';
      } else if (data.link === 'theme') {

        setLoading(data.link);

        if (currentUserSetting?.theme === 'dark') {
          await updateUserSetting({ ...currentUserSetting, theme: 'light' })
          // reduxDispatch(setUserTheme('light'));
        } else {
          await updateUserSetting({ ...currentUserSetting, theme: 'dark' })
          // reduxDispatch(setUserTheme('dark'));
        }
        // setTimeout(() => {
        //   setLoading(false);
        // }, [1000])
        setLoading(false);
      } else {
        navigate(`/${data.link}`, {
          state: {
            structure: data?.structure,
          },
        });
      }
      if (!location?.pathname.includes(data?.link)) {
        const regex = /\/([a-zA-Z]+)\b/;
        const match = location.pathname.match(regex);

        if (match) {
          const word = match[1];
          const index = mainDrawerJsonState.findIndex(
            item => item.link === word
          );
          handleIsActive(index);
        } else {
          console.log('No match found.');
        }
        console.log(mainDrawerJsonState);
      }
    }
  };

  const mainDrawerStaticContent = (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: mainAppBarDimen.height,
          ...(mainDrawerOpen && {
            justifyContent: 'flex-end',
          }),
        }}
      >
        {mainDrawerOpen ? (
          <IconButton
            onClick={() => dispatch({ type: ACTION_CLOSE_MAIN_DRAWER })}
          >
            <Icon
              sx={{
                color: 'drawerIcon',
              }}
            >
              chevron_left
            </Icon>
          </IconButton>
        ) : (
          <IconButton
            onClick={() => dispatch({ type: ACTION_OPEN_MAIN_DRAWER })}
          >
            <Icon
              sx={{
                color: 'drawerIcon',
              }}
            >
              menu
            </Icon>
          </IconButton>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: mainDrawerOpen && '-20px',
        }}
      >
        <IconButton
          onClick={() => {
            navigate(`/home/dashboard`, { replace: true });
          }}
        >
          <MultyMedLogo
            backgroundColor={'#fff'}
            width={
              mainDrawerOpen
                ? mainLogoDimen.open.width
                : mainLogoDimen.closed.width
            }
            height={
              mainDrawerOpen
                ? mainLogoDimen.open.height
                : mainLogoDimen.closed.height
            }
          />
        </IconButton>
        {
          mainDrawerOpen &&
          <Typography
            sx={{
              color: 'drawerIcon',
              fontWeight:100
            }}
            align="center"
          >
            {APP_NAME?.split('C')?.[0]}<span style={{fontWeight: 600}}>{APP_NAME?.split('v')?.[1]}</span>
          </Typography>
        }

      </Box>
      <Divider
        sx={{
          backgroundColor: '#fff',
          height: 2,
        }}
      />
    </Box>
  );

  console.log(loading)

  const MainDrawerDynamicContent = ({ sideBarList }) => (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        mt={1}
      >
        {sideBarList?.map((data, index) => {
          return (
            <>
              <ListItemButton
                onClick={(event) => {
                  const selectIndex = findIndex(mainDrawerJsonState, { link: data?.link });
                  if (data?.name !== 'Change Language') {
                    handleIsActive(selectIndex);
                  }
                  handleOnClick(event, data.submenu.length > 0, data);
                }}
                key={data.name}
                sx={{
                  justifyContent: mainDrawerOpen ? 'initial' : 'center',
                  background: `${data.isActive && '#8357db'}`,
                  padding: '8px 0px',
                  margin: 0,
                }}
                disableTouchRipple
                disabled={loading && data?.link === 'theme'}
              >
                <Tooltip
                  disableInteractive
                  title={
                    // !data?.isAvatar ?
                    data.link === 'theme'
                      ? !isDarkMode
                        ? i18n.t('common.SWITCH_TO_DARK_MODE')
                        : i18n.t('common.SWITCH_TO_LIGHT_MODE')
                      : i18n.t(`common.${data?.title}`)
                    // :''  
                  }
                  placement="right"
                >
                  {loading === data?.link ? <>
                    <CircularProgress color='success' size={20} />
                  </> : <ListItemIcon
                    sx={{
                      justifyContent: 'center',
                    }}
                  >
                    <Icon
                      sx={{
                        color: 'drawerIcon',
                        fontSize: 19,
                      }}
                    >
                      {!data.isAvatar && data.icon === 'theme'
                        ? !isDarkMode
                          ? 'dark_mode'
                          : 'light_mode'
                        : data.icon}
                    </Icon>

                    {data?.isAvatar ? (
                      <Avatar
                        sx={{ marginLeft: -2.4, height: '25px', width: '25px' }}
                        src={loggedInUserData?.photoURL}
                      >
                        {loggedInUserData?.displayName?.[0]}
                      </Avatar>
                    ) : (
                      ''
                    )}
                  </ListItemIcon>}
                </Tooltip>
                {mainDrawerOpen &&
                  //  !data?.isAvatar &&
                  (
                    <div
                      className='fxs'
                      style={{
                        opacity: mainDrawerOpen ? 1 : 0,
                        color: '#fff',
                        fontSize: 12,

                        marginLeft: -2.5,
                      }}
                    >
                      {data?.link === 'theme'
                        ? !isDarkMode
                          ? i18n.t('common.DARK_MODE')
                          : i18n.t('common.LIGHT_MODE')
                        : i18n.t(`common.${data?.title}`)}
                    </div>
                  )}
              </ListItemButton>
              {data?.link === 'translate' && (
                <Menu
                  sx={{
                    '& .MuiMenu-list': {
                      backgroundColor:
                        currentUserSetting?.theme === 'light'
                          ? '#3d2470'
                          : '#3d2470',
                    },
                  }}
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {data?.submenu?.map((item, index) => {
                    return (
                      <MenuItem
                        style={{
                          color:
                            item?.value === currentUserSetting?.language ? '#3d2470' :
                              currentUserSetting?.theme === 'light'
                                ? '#fff'
                                : 'whitesmoke',
                          background:
                            item?.value === currentUserSetting?.language ? 'whitesmoke' :
                              currentUserSetting?.theme === 'light'
                                ? '#3d2470'
                                : '#3d2470',
                        }}
                        key={index}
                        onClick={() => {
                          changeLang(item?.value);
                        }}
                      >
                        {item?.label}
                      </MenuItem>
                    );
                  })}
                </Menu>
              )}
            </>
          );
        })}
      </Box>
    </>
  );

  const sideBarList = currentUserSetting?.isAdmin && isLoggedInAsAdmin
    ? mainDrawerJsonState?.slice(0, -5).filter(item => !item.hasOwnProperty('userModule'))
    : mainDrawerJsonState?.slice(0, -5).filter(item => !item.hasOwnProperty("adminModule"));

  return (
    <>
      {
        !isMobileResolution ?
          <NVDrawer
            key={isLoggedInAsAdmin}
            vh={height}
            vw={width}
            open={mainDrawerOpen}
            variant="permanent"
            style={{zIndex:1198}}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100vh',
              }}
            >
              <Box>
                {mainDrawerStaticContent}
                <MainDrawerDynamicContent sideBarList={sideBarList} />
              </Box>
              <Box>
                <Divider
                  sx={{
                    height: 2,
                    backgroundColor: '#fff',
                  }}
                />
                <MainDrawerDynamicContent sideBarList={mainDrawerJsonState?.slice(-5)} />
              </Box>
            </Box>
          </NVDrawer>
          : mainDrawerOpen &&
          <NVDrawer
            vh={height}
            vw={width}
            open={mainDrawerOpen}
            variant="permanent"
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100vh',
              }}
            >
              <Box>
                {mainDrawerStaticContent}
                <MainDrawerDynamicContent sideBarList={sideBarList} />
              </Box>
              <Box>
                <Divider
                  sx={{
                    height: 2,
                    backgroundColor: '#fff',
                  }}
                />
                <MainDrawerDynamicContent sideBarList={mainDrawerJsonState?.slice(-5)} />
              </Box>
            </Box>
          </NVDrawer>
      }
    </>
  );
};

export default MDrawer;
